/* eslint-disable max-len */
import { defaultAttributes } from "@Components/Component";

import { IconBase } from "./IconBase";

export class Alert extends IconBase {
    protected cssClassName: string | null = null;

    protected get icon(): JSX.Element {
        return (
            <svg {...defaultAttributes(this.props)} viewBox="0 0 251.3 252">
                <g>
                    <path d="M125.5,1C56.8,1,1,56.9,1,125.5c0,68.7,55.9,124.5,124.5,124.5c68.7,0,124.5-55.9,124.5-124.5 C250,56.9,194.1,1,125.5,1z M125.5,237.7c-61.9,0-112.2-50.3-112.2-112.2S63.6,13.4,125.5,13.4s112.2,50.3,112.2,112.2 S187.3,237.7,125.5,237.7z" />
                    <rect
                        x="108.5"
                        y="43"
                        transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 250.9573 191.6454)"
                        width="34"
                        height="105.7"
                    />
                    <rect
                        x="108.5"
                        y="176.6"
                        transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 250.9573 384.6905)"
                        width="34"
                        height="31.6"
                    />
                </g>
            </svg>
        );
    }
}
